/**
 * @module:  黄豆m站页面映射
 * @author: Liang Huang
 * @date: 2020-01-03 18:39:29
 */

import { lazy } from 'react';
import { retry } from '@src/utils/tool';
import { initConfig, weChatFn } from '@src/utils/wechatShare.js';
import { isWeiXin } from '@src/utils/ua';
import { urlFn } from '@src/utils/index';
// 黄豆m站登录
export const MResidentLogin = lazy(() => retry(() => import('@MResident/Login/Login')));
// 黄豆m站注册
export const MResidentRegister = lazy(() => retry(() => import('@MResident/Login/Register')));
// 黄豆注册完创建企业
export const MResidentCreate = lazy(() => retry(() => import('@MResident/Create/index')));
// 黄豆注册完创建企业
export const MResidentCreateSuccess = lazy(() => retry(() => import('@MResident/CreateSuccess/index')));

// 黄豆m站首页
export const MResidentHome = lazy(() => retry(() => import('@MResident/Home/index')));
// 黄豆m站搜索页
export const MResidentSearsh = lazy(() => retry(() => import('@MResident/Search/index')));
export const MJobSuggest = lazy(() => retry(() => import('@MResident/JobSuggest/index')));
// 黄豆拉新页面
export const LachineHome = lazy(() => retry(() => import('@MResident/Lachine/LachineHome/index')));
// 黄豆拉新去活动页面
export const LachineActive = lazy(() => retry(() => import('@MResident/Lachine/LachineActive/index')));
// 黄豆拉新输入手机号页面
export const LachinePhone = lazy(() => retry(() => import('@MResident/Lachine/LachinePhone/index')));
// 黄豆拉新二维码页面
export const LachineQrcode = lazy(() => retry(() => import('@MResident/Lachine/LachineQrcode/index')));
// 黄豆拉新验证码页面
export const LachineYzm = lazy(() => retry(() => import('@MResident/Lachine/LachineYzm/index')));
// 全民推荐活动页面
export const RecommendActive = lazy(() => retry(() => import('@MResident/RecommendActive/index')));
// 全民推荐活动引导页面
export const RecommendGuide = lazy(() => retry(() => import('@MResident/RecommendActive/RecommendGuide/index')));
// 邀请投递成功页
export const InviteSuccess = lazy(() => retry(() => import('@MResident/InviteSuccess/index')));
// 线上测试唤起页
export const WakeTest = lazy(() => retry(() => import('@MResident/WakeTest/index')));
const flag = urlFn.getFirstPathName();
// 判断是否是微信环境
if (isWeiXin() && flag === 'mresident') {
  initConfig();
  if (window.location.pathname === '/mresident/recommend/active') {
    weChatFn({
      title: '黄豆纳才，全民推荐开始啦！',
      desc: '黄豆纳才全民推荐，参与无门槛、佣金无上限，快来开启副业赚钱吧。',
      link: encodeURI(window.location.href),
      imgUrl: 'https://cloudwork.oss-cn-beijing.aliyuncs.com/%E7%94%BB%E6%9D%BF.png'
    });
  } else {
    weChatFn();
  }
}
